import { Dayjs } from 'dayjs'
import { ReactNode, VFC } from 'react'
import { ClockIcon, DocumentIcon, TemplateIcon } from 'src/assets/svgs'
import { TooltipWrapper } from 'src/components/Tooltip'
import { useErrorMessageModal } from 'src/hooks/useModal'
import { fontWeightBold } from 'src/styles/font'
import { maxUploadFileSizeByte, maxUploadFileSizeMB } from 'src/utils/data'
import { formatScheduledTime } from '../utils'
import styled from 'styled-components'

type MessageFormToolbarProps = {
  setMessageTemplateModalOpen: (bool: boolean) => void
  setFiles: (files: File[]) => void
  selectedFiles: File[]
  setScheduleMessageModalOpen: (bool: boolean) => void
  scheduledAt: Dayjs | undefined
}
export const MessageFormToolbar: VFC<MessageFormToolbarProps> = ({
  setMessageTemplateModalOpen,
  setFiles,
  selectedFiles,
  setScheduleMessageModalOpen,
  scheduledAt,
}) => {
  const { open } = useErrorMessageModal()
  return (
    <>
      <MessageFormTooltip tooltip="定型文を挿入する">
        <button onClick={() => setMessageTemplateModalOpen(true)}>
          <TemplateIcon />
        </button>
      </MessageFormTooltip>
      <MessageFormTooltip
        tooltip={`ファイルを添付する（${maxUploadFileSizeMB}MBまで）`}
      >
        <label>
          <input
            type="file"
            accept=".pdf,.jpg,.jpeg,.png,.gif"
            onChange={({ target: { files } }) => {
              if (!files) return

              const fileArray = Array.from(files)
              for (const file of fileArray)
                if (file.size > maxUploadFileSizeByte) {
                  open({
                    message: `ファイルサイズは${maxUploadFileSizeMB}MB以下にしてください`,
                  })
                  return
                }

              setFiles([...selectedFiles, ...fileArray])
            }}
            multiple
            hidden
          />
          <DocumentIcon />
        </label>
      </MessageFormTooltip>
      <MessageFormTooltip tooltip="送信時刻を指定する">
        <button onClick={() => setScheduleMessageModalOpen(true)}>
          <ClockIcon />
          <p>{scheduledAt && `${formatScheduledTime(scheduledAt)}に送信`}</p>
        </button>
      </MessageFormTooltip>
    </>
  )
}

type MessageHeaderTooltipProps = {
  tooltip: string
  children: ReactNode
}
const MessageFormTooltip: VFC<MessageHeaderTooltipProps> = ({
  tooltip,
  children,
}) => (
  <MessageFormTooltipDiv>
    <TooltipWrapper
      tooltipNode={tooltip}
      direction={{ y: 'top', x: 'right' }}
      yValue="18px"
      xValue={`-50px`}
    >
      {children}
    </TooltipWrapper>
  </MessageFormTooltipDiv>
)

const MessageFormTooltipDiv = styled.div`
  font-weight: ${fontWeightBold};
`
